import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=6e698d25&scoped=true&"
import script from "./Advantages.vue?vue&type=script&lang=js&"
export * from "./Advantages.vue?vue&type=script&lang=js&"
import style0 from "./Advantages.vue?vue&type=style&index=0&id=6e698d25&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e698d25",
  null
  
)

export default component.exports